module.exports = __webpack_public_path__ + "img/nocar.ceb695de.png";